import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fileApiRoutes } from './routes';
import { requestService } from 'src/core/services/api';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { HttpStatusCode } from 'axios';
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';
export class FileApi {
  constructor() {
    _defineProperty(this, "routes", fileApiRoutes);
  }
  async uploadFile(data, options) {
    const formData = new FormData();
    formData.append('file', data.file);
    const resp = await requestService('file').post(this.routes.upload, formData, _objectSpread(_objectSpread({}, options.cancelToken), {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }));
    return resp.data;
  }
  async deleteFile(data, options) {
    // const resp = await requestService('file').delete<void>(this.routes.baseUrl + `?fileId=${data.fileId}`, {
    const resp = await requestService('file').delete(this.routes.baseUrl, null, _objectSpread({
      params: {
        fileId: data.fileId
      }
    }, options.cancelToken));
    return resp.data;
  }
  async downloadFile(body, options) {
    const resp = await requestService('file').get(this.routes.download(body), _objectSpread(_objectSpread({}, options.cancelToken), {
      headers: {
        accept: 'application/octet-stream',
        'Content-Type': 'application/json-patch+json'
      },
      responseType: 'blob'
    }));
    return resp;
  }
  async downloadFileArchive(body, options) {
    const resp = await requestService('file').post(this.routes.downloadArchive, body, _objectSpread(_objectSpread({}, options.cancelToken), {
      headers: {
        accept: 'application/octet-stream',
        'Content-Type': 'application/json-patch+json'
      },
      responseType: 'blob'
    }));
    return resp;
  }
  async getFileInfo(data, options) {
    const fileId = data.fileId;
    const resp = await requestService('file').post(this.routes.fileInfo(fileId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getFilesInfo(data, options) {
    const resp = await requestService('file').post(this.routes.filesInfo, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  // TODO: remove this method if it's not used when this flag got released store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled
  // async convertToImage(data: IСonvertToImage, options: TAsyncActionOptions): Promise<void> {
  //   const formData = new FormData();
  //   formData.append('formFile', data.formFile);
  //
  //   const resp = await requestService('paperCorrespondence').post<void>(this.routes.convertToImage, formData, {
  //     ...options.cancelToken,
  //     ...{
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //       responseType: 'blob',
  //     },
  //   });
  //
  //   return resp.data;
  // }

  async convertToImageById(data, options) {
    const restConfig = {};
    // NOTE: This is a temporary solution, when this flag got released store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled remove this blob if part
    if (!(data !== null && data !== void 0 && data.useBlogResp)) {
      restConfig.responseType = 'blob';
    }
    const resp = await requestService('paperCorrespondence').get(this.routes.convertToImageById(data.fileId), _objectSpread(_objectSpread({}, options.cancelToken), restConfig));
    return resp.data;
  }

  // NOTE: when this flag got released store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled we need to remove this method
  downloadFilePreviewLink(body) {
    return "".concat(requestService('file').getBaseUrl()).concat(this.routes.downloadPreview, "?fileId=").concat(body.fileId, "\n  &accessToken=").concat(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken));
  }
  async uploadFileViaPresignedUrl(data, options) {
    const respUploadUrl = await requestService(API_SERVICE_NAMES.FILE).get(this.routes.presignedFileGetUploadUrl, _objectSpread({}, options.cancelToken));
    const _respUploadUrl$data = respUploadUrl.data,
      respUploadUrlStatus = _respUploadUrl$data.isSuccessful,
      responseRespUploadUrl = _respUploadUrl$data.response;
    if (respUploadUrlStatus) {
      var _data$file;
      const fileKey = responseRespUploadUrl.fileKey,
        preSignedUrl = responseRespUploadUrl.preSignedUrl;
      const formData = new FormData();
      formData.append('file', data.file);
      const uploadBinaryResponse = await requestService(API_SERVICE_NAMES.ANONYMOUS).put(preSignedUrl, data.file, _objectSpread({}, {
        headers: {
          'Content-Type': (_data$file = data.file) === null || _data$file === void 0 ? void 0 : _data$file.type
        }
      }));
      if (uploadBinaryResponse.status === HttpStatusCode.Ok) {
        var _data$file2;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const respSetFileMetaData = await requestService('file').put(this.routes.presignedFileSetUploadUrl, {
          fileKey,
          fileName: (_data$file2 = data.file) === null || _data$file2 === void 0 ? void 0 : _data$file2.name,
          createdBy: data.createdBy
        }, _objectSpread({}, options.cancelToken));
        return respSetFileMetaData.data;
      } else {
        return {
          isSuccessful: false,
          response: uploadBinaryResponse.data
        };
      }
    } else {
      return {
        isSuccessful: false,
        response: respUploadUrl.data
      };
    }
  }

  /* NOTE: This methods below are not used in the project, it's just for example if we need to use them separately
  // async getPresignedFileUploadUrl(options: TAsyncActionOptions): Promise<void> {
  //   const resp = await requestService('file').get<void>(this.routes.presignedFileGetUploadUrl, {
  //     ...options.cancelToken,
  //   });
  //
  //   return resp.data;
  // }
  //
  // async setPresignedFileUploadUrl(data: ISetPresignedFile, options: TAsyncActionOptions): Promise<void> {
  //   const resp = await requestService('file').put<void>(
  //     this.routes.presignedFileSetUploadUrl,
  //     { ...data },
  //     {
  //       ...options.cancelToken,
  //     }
  //   );
  //
  //   return resp.data;
  // }
   */

  async getPresignedFileDownloadUrl(data, options) {
    const resp = await requestService('file').get(this.routes.presignedFileGetDownloadUrl + "?fileId=".concat(data.fileId, "&isPreview=").concat(data.isPreview), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPresignedFileArchiveDownloadUrl(data, options) {
    const resp = await requestService('file').post(this.routes.presignedFileGetArchiveDownloadUrl, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async requestPreviewLink(data, options) {
    const resp = await requestService('file').get(this.routes.requestPreviewLinkUrl(data.fileId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}